import angular from 'angular';
import moment from 'moment';

angular.module('cloudX').directive('cxEidUpload', [
  '$timeout',
  'flySvc',
  '$compile',
  function($timeout, flySvc, $compile) {
    return {
      scope: {
        upload: '&',
      },
      link: function(scope, element) {
        var draggingClass = 'dragover';
        var inputId = 'fileInput' + Math.random();
        var inputWrapper = angular.element(
          `<div><label class="margin10B" for=${inputId}
            >{{'Select .eid file or drag and drop passport photograph from eID viewer here.' | translate}}</label></div>`,
        );
        var input = angular.element(
          '<input id="' + inputId + '" type="file" accept=".eid, plain/text" />',
        );
        input.addClass('form-control');
        inputWrapper.append(input);

        $compile(inputWrapper)(scope);

        element.append(inputWrapper);

        var readEidXml = function(xml) {
          try {
            var parser = new DOMParser();
            var xmlDoc = parser.parseFromString(xml, 'text/xml');
            var identity = xmlDoc.getElementsByTagName('identity')[0];

            var cardInformation = {};

            cardInformation.xml = xml;
            cardInformation.lastName = identity.getElementsByTagName(
              'name',
            )[0].childNodes[0].nodeValue;

            if (identity.getElementsByTagName('firstname')[0].childNodes.length > 0) {
              cardInformation.firstName = identity.getElementsByTagName(
                'firstname',
              )[0].childNodes[0].nodeValue;
            }

            if (identity.getElementsByTagName('middlenames')[0].childNodes.length > 0) {
              cardInformation.firstNameOfficial =
                cardInformation.firstName +
                ' ' +
                identity.getElementsByTagName('middlenames')[0].childNodes[0].nodeValue;
            }

            cardInformation.nationality = identity.getElementsByTagName(
              'nationality',
            )[0].childNodes[0].nodeValue;
            cardInformation.placeOfBirth = identity.getElementsByTagName(
              'placeofbirth',
            )[0].childNodes[0].nodeValue;
            cardInformation.nationalNumber = identity.getAttribute('nationalnumber');
            cardInformation.gender = identity.getAttribute('gender');
            cardInformation.dateOfBirth = moment.utc(identity.getAttribute('dateofbirth')).toDate();
            cardInformation.cardNumber = xmlDoc
              .getElementsByTagName('card')[0]
              .getAttribute('cardnumber');
            cardInformation.cardExpiryDate = moment
              .utc(xmlDoc.getElementsByTagName('card')[0].getAttribute('validitydateend'))
              .toDate();
            cardInformation.street = xmlDoc
              .getElementsByTagName('address')[0]
              .getElementsByTagName('streetandnumber')[0].childNodes[0].nodeValue;
            cardInformation.zip = xmlDoc
              .getElementsByTagName('address')[0]
              .getElementsByTagName('zip')[0].childNodes[0].nodeValue;
            cardInformation.city = xmlDoc
              .getElementsByTagName('address')[0]
              .getElementsByTagName('municipality')[0].childNodes[0].nodeValue;
            cardInformation.photo = identity.getElementsByTagName(
              'photo',
            )[0].childNodes[0].nodeValue;

            scope.$apply(function() {
              scope.upload({
                eid: cardInformation,
              });
            });
          } catch (error) {
            $timeout(function() {
              console.error(error);
              //Failed to parse eid XML
              flySvc.error(6022);
            }, 0);
          }
        };

        var readXmlFromFile = function(file) {
          var reader = new FileReader();
          reader.readAsText(file);
          reader.onloadend = function(event) {
            if (event.target.readyState === FileReader.DONE) {
              // DONE == 2
              if (!event.target.result) return;
              readEidXml(event.target.result);
            }
          };
        };
        element.attr('draggable', 'true');
        element.on('dragover', function(event) {
          event.preventDefault();
        });

        var processDragOverOrEnter = function(event) {
          if (event == null) return false;

          var dataTransfer = event.dataTransfer || event.originalEvent.dataTransfer;
          if (!dataTransfer) return false;

          if (dataTransfer.items && dataTransfer.items.length > 0) {
            var file = dataTransfer.items[0];
            if (file.type !== 'text/plain' && file.type !== '') {
              //Eid file has no file type, dragging text is text/plain
              dataTransfer.dropEffect = 'none';
              return false;
            }
          }

          event.preventDefault();

          dataTransfer.effectAllowed = 'copy';
          dataTransfer.dropEffect = 'copy';
          element.addClass(draggingClass);
          return true;
        };

        input.bind('change', function(event) {
          if (event && event.target) {
            if (event.target.files && event.target.files.length > 0) {
              var file = event.target.files[0];
              if (file.type !== '') {
                //.eid file has empty type
                event.target.value = '';
                $timeout(function() {
                  flySvc.error(2022, ['.eid']);
                }, 0);
                return;
              }
              readXmlFromFile(file);
            }
            event.target.value = '';
          }
        });
        element.on('drop', function(event) {
          element.removeClass(draggingClass);
          var dataTransfer = event.dataTransfer || event.originalEvent.dataTransfer;
          if (!dataTransfer) return;

          event.preventDefault();

          if (dataTransfer.types.indexOf('Files') >= 0) {
            if (dataTransfer.files.length < 1) return;
            var file = dataTransfer.files[0];
            console.debug(file);

            readXmlFromFile(file);
          }

          if (dataTransfer.types.indexOf('text/plain') >= 0) {
            var xml = event.originalEvent.dataTransfer.getData('Text');
            readEidXml(xml);
          }
        });

        var processDragLeaveOrEnd = function(event) {
          element.removeClass(draggingClass);
          return false;
        };

        element.bind('dragover', processDragOverOrEnter);
        element.bind('dragenter', processDragOverOrEnter);
        element.bind('dragleave', processDragLeaveOrEnd);
        element.bind('dragend', processDragLeaveOrEnd);
      },
    };
  },
]);
